module.exports = __webpack_public_path__ + "media/images/river/versatile-944ebed92742a01565e455f31ddcfd66.png";